export default class MaintenanceService {
  constructor(axios) {
    this.axios = axios
  }

  /**
   * @param {string} id
   */
  async endpoints(id) {
    const { data: { data } } = await this.axios.get(`maintenance/modules/${id}/endpoints`)
    return data
  }

  async modules() {
    const { data: { data } } = await this.axios.get('maintenance/modules/list-all')
    return data
  }
}
